// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Core Components
import DateTime from './date-time';

// Containers
import withFormField from '../../containers/with-form-field';

// Styles
import './date-range.scss';

class DateRange extends Component {
    getClass() {
        const {className} = this.props;

        return classnames(className, 'date-range');
    }

    getDateTimeProps(name) {
        const {showTime} = this.props;

        return {
            className: 'date-range--date-time',
            formIsSearch: true,
            name,
            showTime,
            parseFormat: showTime ? 'YYYY-MM-DDTHH:mm:ssZ' : 'YYYY-MM-DD',
        };
    }

    visible() {
        return true;
    }

    render() {
        const {name} = this.props;

        return (
            <div className={this.getClass()}>
                <DateTime {...this.getDateTimeProps(`${name}.dateRange.from`)} visible={this.visible} />
                <div className="date-range--to">to</div>
                <DateTime {...this.getDateTimeProps(`${name}.dateRange.to`)} visible={this.visible} />
            </div>
        );
    }
}

DateRange.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    showTime: PropTypes.bool,
};

export default withFormField(DateRange);
